/*
 * @Author: your name
 * @Date: 2021-08-25 19:25:23
 * @LastEditTime: 2021-11-08 18:15:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\api\user.js
 */

import http from '@/utils/http'

// 用户登录
export function getLogin(data) {
  return http({
    url: 'ahan/login',
    method: 'post',
    data
  })
}

// 用户注册
export function CreateUser(data) {
  return http({
    url: 'ahan/register',
    method: 'post',
    data
  })
}

// 用户列表
export function GetUserList(data = {}) {
  return http({
    url: 'ahan/getui',
    method: 'post',
    data
  })
}

// 用户信息修改
export function UserDataChange(data = {}) {
  return http({
    url: 'ahan/editui',
    method: 'post',
    data
  })
}

// 用户删除
export function UserDataDelete(data = {}) {
  return http({
    url: 'ahan/delui',
    method: 'post',
    data
  })
}

// 获取分配卷
export function getchapter(data) {
  return http({
    url: 'ahan/new/getchapter',
    method: 'post',
    data
  })
}

// 获取卷分类
export function gettype(data = {}) {
  return http({
    url: 'ahan/new/gettype',
    method: 'post',
    data
  })
}

// 设置卷分配
export function chapter2u(data) {
  return http({
    url: 'ahan/new/chapter2u',
    method: 'post',
    data
  })
}

// 获取文件列表接口
export function getfile(data) {
  return http({
    url: 'ahan/new/getfile',
    method: 'post',
    data
  })
}

// 设置文件与用户关联权限接口
export function file2u(data) {
  return http({
    url: 'ahan/new/file2u',
    method: 'post',
    data
  })
}

// 获取所有用户登录信息
export function getuh(data = {}) {
  return http({
    url: 'ahan/getuh',
    method: 'post',
    data
  })
}

// 获取用户登录信息接口
export function gethistory(data = {}) {
  return http({
    url: 'ahan/gethistory',
    method: 'post',
    data
  })
}
